import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type {
  EstimateImageLocation,
  EstimateRequestEstimationStatus,
  EstimateRequestPaymentMethod,
  EstimateRequestReplyType,
  EstimateRequestStatus,
} from "../entities";

export function useEstimateRequestEnumTranslations() {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:useEstimateRequestEnumTranslations",
  });
  const translationsMap = useMemo(() => {
    const EstimateRequestStatusMap: Record<EstimateRequestStatus, string> = {
      Archived: t("EstimateRequestStatus.Archived"),
      Requested: t("EstimateRequestStatus.Requested"),
    };
    const EstimateRequestPaymentMethod: Record<
      EstimateRequestPaymentMethod,
      string
    > = {
      Invalid: t("EstimateRequestPaymentMethod.Invalid", "Invalid"),
      Unknown: t("EstimateRequestPaymentMethod.Unknown", "Unknown"),
      CustomerPay: t("EstimateRequestPaymentMethod.CustomerPay", "CustomerPay"),
      InsurerPay: t("EstimateRequestPaymentMethod.InsurerPay", "InsurerPay"),
    };

    const EstimateRequestReplyTypeMap: Record<
      EstimateRequestReplyType,
      string
    > = {
      NotContacted: t("EstimateRequestReplyType.NotContacted"),
      Email: t("EstimateRequestReplyType.Email"),
      Phone: t("EstimateRequestReplyType.Phone"),
    };

    const EstimateImageLocationMap: Record<EstimateImageLocation, string> = {
      DefaultInvalid: t("EstimateRequestImageLocation.DefaultInvalid"),
      FrontLeft: t("EstimateRequestImageLocation.FrontLeft"),
      FrontCenter: t("EstimateRequestImageLocation.FrontCenter"),
      FrontRight: t("EstimateRequestImageLocation.FrontRight"),
      SideLeft: t("EstimateRequestImageLocation.SideLeft"),
      SideRight: t("EstimateRequestImageLocation.SideRight"),
      BackLeft: t("EstimateRequestImageLocation.BackLeft"),
      BackCenter: t("EstimateRequestImageLocation.BackCenter"),
      BackRight: t("EstimateRequestImageLocation.BackRight"),
      Top: t("EstimateRequestImageLocation.Top"),
      Vin: t("EstimateRequestImageLocation.Vin"),
      Other: t("EstimateRequestImageLocation.Other", "Other"),
    };
    const EstimateRequestEstimationStatusMap: Record<
      EstimateRequestEstimationStatus,
      string
    > = {
      NotEstimated: t("EstimateRequestEstimationStatus.NotEstimated"),
      EstimationUndetermined: t(
        "EstimateRequestEstimationStatus.EstimationUndetermined"
      ),
      Estimated: t("EstimateRequestEstimationStatus.Estimated"),
    };

    return {
      EstimateRequestStatus: EstimateRequestStatusMap,
      EstimateRequestReplyType: EstimateRequestReplyTypeMap,
      EstimateImageLocation: EstimateImageLocationMap,
      EstimateRequestEstimationStatus: EstimateRequestEstimationStatusMap,
      EstimateRequestPaymentMethod: EstimateRequestPaymentMethod,
    } as const;
  }, [t]);
  return translationsMap;
}
